import { useState } from 'react'
import type { ChecklistReasonInput, MessageOption } from '../../api/types'
import { Dialog } from '../../components/Dialog'

const MAX_REASON = 200

interface Props {
  /** The items not ticked. */
  items: MessageOption[]
  onCancel: () => void
  onSend: (reasons: ChecklistReasonInput[]) => void
}

/** Done with items not ticked: a reason for each, required, before the summary goes. It scrolls; Cancel and Send stay at the top. */
export function ReasonsDialog({ items, onCancel, onSend }: Props) {
  const [reasons, setReasons] = useState<Record<string, string>>({})
  const ready = items.every((item) => (reasons[item.id] ?? '').trim().length > 0)
  return (
    <Dialog
      chrome="bar"
      open
      onClose={onCancel}
      title="Why weren't these done?"
      titleId="checklist-reasons-title"
      closeLabel="Cancel"
      className="reasons-dialog"
      action={
        <button type="submit" form="checklist-reasons-form" className="bar-button bar-action" disabled={!ready}>
          Send
        </button>
      }
    >
      <form
        id="checklist-reasons-form"
        style={{ display: 'contents' }}
        onSubmit={(event) => {
          event.preventDefault()
          if (ready) onSend(items.map((item) => ({ itemId: item.id, reason: reasons[item.id].trim() })))
        }}
      >
        <div className="dialog-body reasons-list">
          {items.map((item, index) => (
            <label key={item.id} className="reason-field">
              <span>{item.label}</span>
              <input
                type="text"
                maxLength={MAX_REASON}
                placeholder="Why not?"
                value={reasons[item.id] ?? ''}
                data-autofocus={index === 0 ? true : undefined}
                onChange={(event) => {
                  const value = event.target.value
                  setReasons((current) => ({ ...current, [item.id]: value }))
                }}
              />
            </label>
          ))}
        </div>
      </form>
    </Dialog>
  )
}
